//免费专区 itemList
import React from 'react'
import {browserHistory} from 'react-router'
import '../../css/component/freeLecture/FreeLectureCardViewItem.css'

class FreeLectureItemCardView extends React.Component {

    renderLearnNum(num) {
        if(num.toString().length>4) {
            return (num / 10000).toFixed(2) + '万'
        }else {
            return num
        }
    }

    freeListen(lecture_id,isAccepted) {
        if(isAccepted===true){
            window.location.assign(`${window.location.origin}/lecture/${lecture_id}?inviter_id=43611144&st=index_free`)
        }else{
            location.assign(`/specials/freeCard?lecture_id=${lecture_id}`)
        }
    }

    render() {
        const {content} = this.props
        return (
            <div className="freeLecture-CardView-list-item" onClick={this.freeListen.bind(this,content.id,content.accepted)}>
                <div className="freeLecture-cover" style={{backgroundImage: `url(${content.cover_url})`}}>

                </div>

                <div className="freeLecture-bottomItem-wrap">
                    <div className="freeLecture-title">
                        {content.name}
                    </div>
                    <div className="freeLecture-num">
                        <div className="freeLecture-learnNum"><span>{this.renderLearnNum(content.popular)}</span>人在学</div>
                        <div><i className="origin-price">原价¥ {content.lecture_money}</i></div>
                    </div>
                    <div className="freeLecture-listen-bottom">{content.accepted ? '立即听课' :'免费听' }</div>
                </div>
            </div>
        )
    }
}

export default FreeLectureItemCardView


// WEBPACK FOOTER //
// ./src/components/freeLecture/FreeLectureItemCardView.js